<div class="acumulados-search-dialog">
  <div class="criteria-row">
    <div class="field-group">
      <label for="lab">{{ 'ACUMULADOS.LABORATORIO' | translate }}</label>
      <p-dropdown
        id="lab"
        [options]="labOptions"
        [(ngModel)]="selectedLab"
        optionLabel="label"
        [filter]="true"
        placeholder="{{ 'ACUMULADOS.LABORATORIO' | translate }}"
        (onChange)="onLabChange()"
        styleClass="w-full"
      ></p-dropdown>
    </div>
    <div class="field-group">
      <label for="refDate">{{ 'ACUMULADOS.ANTERIORES_A_LABEL' | translate }}</label>
      <p-calendar
        id="refDate"
        inputId="refDate"
        [(ngModel)]="referenceDate"
        [minDate]="minDate"
        [maxDate]="maxDate"
        dateFormat="dd/mm/yy"
        [readonlyInput]="true"
        [firstDayOfWeek]="1"
        [showClear]="false"
        [showButtonBar]="true"
        (ngModelChange)="onReferenceDateModelChange($event)"
        appendTo="body"
        panelStyleClass="acumulados-datepicker-panel"
      ></p-calendar>
    </div>
  </div>

  <div class="panel-technicas">
    <p-panel
      [header]="'ACUMULADOS.TECNICAS_PANEL' | translate"
      [toggleable]="!panelTechnicasDisabled"
      [collapsed]="technicasPanelCollapsed"
      (collapsedChange)="onTechnicasPanelCollapsedChange($event)"
    >
      <afoone-select-shopping-cart
        [availableItems]="availableItemsForCart"
        [(ngModel)]="selectedTestsForCart"
        [leftTitle]="'ACUMULADOS.TECNICAS_DISPONIBLES' | translate"
        [rightTitle]="'ACUMULADOS.TECNICAS_SELECCIONADAS' | translate"
      >
      </afoone-select-shopping-cart>
      <p *ngIf="loadingTests" class="loading-tests">Cargando...</p>
    </p-panel>
  </div>

  <p-message *ngIf="errorMessage" severity="error" [text]="errorMessage" styleClass="w-full"></p-message>

  <div class="actions-row">
    <div class="actions-buttons">
      <p-button
        [label]="'ACUMULADOS.BUSCAR' | translate"
        icon="pi pi-search"
        (onClick)="buscar()"
        [loading]="loadingSearch"
        [disabled]="!canSearchTable"
        styleClass="p-button-sm"
      ></p-button>
      <p-button
        [label]="'ACUMULADOS.GRAFICAS_EVOLUCION' | translate"
        icon="pi pi-chart-line"
        (onClick)="graficas()"
        [loading]="loadingSearch"
        [disabled]="!canGraficasEvolucion"
        styleClass="p-button-sm"
      ></p-button>
      <div class="hints-column">
        <span class="hint">{{ 'ACUMULADOS.TESTS_SELECTED_COUNT' | translate: { count: selectedTestsForCart.length } }}</span>
        <span class="hint hint--graficas">{{ 'ACUMULADOS.GRAFICAS_EVOLUCION_RANGO' | translate }}</span>
      </div>
    </div>
  </div>
</div>
